import React from 'react'
import Skeleton from 'react-loading-skeleton'

function PostBannerSkeleton() {
    return (
        <div className="item">
            <div className="row slider-info">
                <div className="col-lg-8 message-info align-self">
                    <a href={`/cateogary/`}><span className="label-blue mb-sm-4 mb-3"><Skeleton width={`4em`} /></span></a>
                    <a href={`/posts/`} style={{ marginBottom: `1px` }}><h3 className="title-big"><Skeleton width={`15em`} /></h3></a>
                    <a href={`/posts/`}><h3 className="title-big mb-4"><Skeleton width={`7em`} /></h3></a>
                    <a href={`/posts/`}><p className="message"></p><Skeleton width={`42em`} height={`1em`} /></a>
                    <a href={`/posts/`}><p className="message"></p><Skeleton width={`22em`} height={`1em`} /></a>
                </div>
                <div className="col-lg-4 col-md-8 img-circle mt-lg-0 mt-4">
                    <Skeleton height={`24em`} />
                </div>
            </div>
        </div>
    )
}

export default PostBannerSkeleton
